var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.3601 12.7301C19.9901 12.7301 19.6801 12.4501 19.6401 12.0801C19.4001 9.88007 18.2201 7.90007 16.4001 6.64007C16.0701 6.41007 15.9901 5.96007 16.2201 5.63007C16.4501 5.30007 16.9001 5.22007 17.2301 5.45007C19.4001 6.96007 20.8001 9.32007 21.0901 11.9301C21.1301 12.3301 20.8401 12.6901 20.4401 12.7301C20.4101 12.7301 20.3901 12.7301 20.3601 12.7301Z",
    fill: "#002C58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.7398 12.7802C3.7198 12.7802 3.6898 12.7802 3.6698 12.7802C3.2698 12.7402 2.9798 12.3802 3.0198 11.9802C3.2898 9.3702 4.6698 7.0102 6.8198 5.4902C7.1398 5.2602 7.5998 5.3402 7.8298 5.6602C8.0598 5.9902 7.9798 6.4402 7.6598 6.6702C5.8598 7.9502 4.6898 9.9302 4.4698 12.1202C4.4298 12.5002 4.1098 12.7802 3.7398 12.7802Z",
    fill: "#002C58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.9901 21.0998C14.7601 21.6898 13.4401 21.9898 12.0601 21.9898C10.6201 21.9898 9.2501 21.6698 7.9701 21.0198C7.6101 20.8498 7.4701 20.4098 7.6501 20.0498C7.8201 19.6898 8.2601 19.5498 8.6201 19.7198C9.2501 20.0398 9.9201 20.2598 10.6001 20.3898C11.5201 20.5698 12.4601 20.5798 13.3801 20.4198C14.0601 20.2998 14.7301 20.0898 15.3501 19.7898C15.7201 19.6198 16.1601 19.7598 16.3201 20.1298C16.5001 20.4898 16.3601 20.9298 15.9901 21.0998Z",
    fill: "#002C58"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.05 2.00977C10.5 2.00977 9.22998 3.26977 9.22998 4.82977C9.22998 6.38977 10.49 7.64977 12.05 7.64977C13.61 7.64977 14.87 6.38977 14.87 4.82977C14.87 3.26977 13.61 2.00977 12.05 2.00977Z",
    fill: "#002C58"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04998 13.8701C3.49998 13.8701 2.22998 15.1301 2.22998 16.6901C2.22998 18.2501 3.48998 19.5101 5.04998 19.5101C6.60998 19.5101 7.86998 18.2501 7.86998 16.6901C7.86998 15.1301 6.59998 13.8701 5.04998 13.8701Z",
    fill: "#002C58"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9499 13.8701C17.3999 13.8701 16.1299 15.1301 16.1299 16.6901C16.1299 18.2501 17.3899 19.5101 18.9499 19.5101C20.5099 19.5101 21.7699 18.2501 21.7699 16.6901C21.7699 15.1301 20.5099 13.8701 18.9499 13.8701Z",
    fill: "#002C58"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.042294946781618e6fd4343ea17019df.svg";
export { ForwardRef as ReactComponent };